// istanbul ignore file
import { usePaymentForm } from 'payments/hooks/usePaymentForm';
import type { PartialSaveOptions } from 'payments/types/form';
import { useSaveCardOnFileMutation } from 'reservations/payments/queries/useSaveCardOnFileMutation';

export function usePaymentProviderSubmission(
  handleSuccess: () => void,
  handle409Error?: () => void
) {
  const saveCardOnFileMutation = useSaveCardOnFileMutation(
    handleSuccess,
    handle409Error
  );
  const submitPaymentForm = usePaymentForm();

  return async (payload?: PartialSaveOptions) => {
    const savedPaymentMethod = payload?.savedPaymentMethod || '';

    if (!submitPaymentForm) {
      throw new Error('submitPaymentForm is not defined');
    }
    const { applySavedPaymentMethod, saveCardOnFile, retrieveToken } =
      submitPaymentForm;

    if (!payload) {
      if (!retrieveToken) {
        throw new Error('retrieveToken is not defined');
      }
      await retrieveToken();
      handleSuccess();
      return;
    }

    const callbackFn = savedPaymentMethod
      ? applySavedPaymentMethod
      : saveCardOnFile;

    callbackFn(payload, formData => {
      saveCardOnFileMutation.mutate(formData);
    });
  };
}
